import React from 'react';
import { Container, SvgIcon, Typography } from '@material-ui/core';
/** A generic splash screen to be presented to a user. */
export function SplashScreen({ icon, iconFontSize = '1.2em', heading, details, children, width = 'sm', }) {
    const headingNode = icon !== null ? (React.createElement(Typography, { variant: 'h3', align: 'center', color: 'textPrimary', gutterBottom: true },
        React.createElement(SvgIcon, { style: { fontSize: iconFontSize }, component: icon }),
        React.createElement("br", null),
        React.createElement("span", null, heading))) : (React.createElement(Typography, { variant: 'h3', align: 'center', color: 'textPrimary', gutterBottom: true }, heading));
    const detailsNode = typeof details === 'string' ? (React.createElement(Typography, { variant: 'h5', align: 'center', color: 'textSecondary', paragraph: true }, details)) : null;
    return (React.createElement(Container, { maxWidth: width },
        headingNode,
        detailsNode,
        children));
}
//# sourceMappingURL=SplashScreen.js.map